import { medicalSpecialityServiceProxy } from '../servicePool';

export function getAll (text = '', callback) {
  medicalSpecialityServiceProxy.searchMedicalSpecialities(100, text).then(data => {
    callback(data);
  });
}
